import { Alert, AlertTitle, Typography } from "@mui/material";

export type ValidationError = {
  loc: Array<string | number>;
  msg: string;
  type: string;
};

interface ImportErrorsProps {
  errors: ValidationError[];
  onClose?: (event) => void;
}

export const ImportErrors: React.FC<ImportErrorsProps> = (props) => (
  <Alert severity="error" onClose={props.onClose} sx={{ mt: 2 }}>
    <AlertTitle>Errors</AlertTitle>
    {props.errors.map((error, index) => {
      const [, lineIndex, field] = error.loc;
      // A line can carry more than one error, so the key is the entry, not the line.
      return (
        <div key={index}>
          <Typography variant="h5">
            Line {(lineIndex as number) + 1}:
          </Typography>
          <Typography paragraph>
            {field === undefined || field === "__root__" ? "" : <strong>{field}</strong>} - {error.msg}{" "}
          </Typography>
        </div>
      );
    })}
  </Alert>
);
